/**
 * Все пользовательские тексты держим здесь: мобильный клиент переиспользует
 * тот же словарь, а правки формулировок не требуют поиска по компонентам.
 */
export const ru = {
  app: {
    title: 'FAVORIT',
    subtitle: 'Театр-студия современной хореографии',
  },
  nav: {
    home: 'Главная',
    news: 'Новости',
    info: 'Общая информация',
    login: 'Войти',
    register: 'Регистрация',
    profile: 'Профиль',
    payments: 'Оплата',
    logout: 'Выйти',
    menu: 'Открыть меню',
    menuClose: 'Закрыть меню',
    administration: 'Администрирование',
    siteLink: 'Вернуться на сайт студии',
  },
  home: {
    title: 'Личный кабинет',
    lead: 'Новости студии, абонементы и оплата занятий — в одном месте.',
    greeting: 'Здравствуйте',
    forParents: 'Для родителей',
    ctaRegister: 'Зарегистрироваться',
    ctaProfile: 'Перейти в профиль',
    cards: {
      newsTitle: 'Новости',
      newsText: 'Объявления студии и вашей группы — без поиска по чатам.',
      paymentTitle: 'Абонементы',
      paymentText: 'Месячный абонемент по каждому ребёнку и оплата картой.',
      docsTitle: 'Документы',
      docsText: 'Договор и квитанции об оплате в одном месте.',
    },
    apiStatusTitle: 'Связь с сервером',
    apiOk: 'сервер отвечает',
    apiFail: 'сервер недоступен',
    apiChecking: 'проверяем…',
  },
  fields: {
    email: 'Электронная почта',
    password: 'Пароль',
    currentPassword: 'Текущий пароль',
    newPassword: 'Новый пароль',
    repeatPassword: 'Повторите пароль',
    lastName: 'Фамилия',
    firstName: 'Имя',
    middleName: 'Отчество',
    phone: 'Телефон',
    optional: ' (необязательно)',
  },
  auth: {
    loginTitle: 'Вход',
    loginSubmit: 'Войти',
    registerTitle: 'Регистрация',
    registerSubmit: 'Зарегистрироваться',
    registerHint: 'Регистрируется родитель. Данные детей добавляются после входа.',
    noAccount: 'Нет учётной записи? Зарегистрироваться',
    hasAccount: 'Уже зарегистрированы? Войти',
    forgotPassword: 'Забыли пароль?',
    forgotTitle: 'Восстановление пароля',
    forgotSubmit: 'Отправить ссылку',
    forgotHint: 'Укажите адрес, на который зарегистрирована учётная запись.',
    resetTitle: 'Новый пароль',
    resetSubmit: 'Сохранить пароль',
    confirmTitle: 'Подтверждение адреса',
    confirmChecking: 'Проверяем ссылку...',
    confirmBadLink: 'Ссылка неполная. Откройте её из письма целиком.',
    goToLogin: 'Перейти ко входу',
    resendConfirmation: 'Выслать письмо ещё раз',
    passwordRule: 'Не менее 8 символов, заглавная и строчная буквы, цифра.',
    passwordsDiffer: 'Пароли не совпадают.',
  },
  profile: {
    title: 'Профиль',
    dataTitle: 'Личные данные',
    save: 'Сохранить',
    saved: 'Изменения сохранены.',
    passwordTitle: 'Смена пароля',
    changePassword: 'Изменить пароль',
    passwordChanged: 'Пароль изменён. Войдите заново.',
    roleAdmin: 'Администратор',
    roleParent: 'Родитель',
  },
  contracts: {
    title: 'Шаблон договора',
    hint: 'Договор родителю собирается из этого шаблона. Чтобы поменять текст: скачайте шаблон, отредактируйте в Word и загрузите обратно — пересборка приложения не нужна.',
    current: 'Сейчас используется',
    builtin: 'Исходный шаблон из поставки',
    custom: 'Загруженный шаблон',
    updatedAt: 'Загружен',
    size: 'Размер',
    download: 'Скачать шаблон',
    upload: 'Загрузить новый',
    reset: 'Вернуть исходный',
    resetConfirm: 'Вернуть исходный шаблон? Загруженный будет удалён.',
    uploaded: 'Шаблон обновлён.',
    resetDone: 'Вернули исходный шаблон.',
    placeholders: 'Подстановки',
    placeholdersHint:
      'Набирайте подстановку одним куском, не разрывая её правками и проверкой орфографии, иначе Word разрежет её на части и она останется в договоре как есть.',
    missing: (list: string) => `В шаблоне нет подстановок: ${list}. Эти поля останутся незаполненными.`,
    fieldParent: 'ФИО родителя — в преамбуле и в реквизитах сторон',
    fieldPhone: 'Телефон родителя; не заполнен — останется прочерк',
    fieldStudent: 'ФИО ученика, дата рождения и группа',
    fieldDate: 'Дата договора: день и месяц с годом',
  },
  requisites: {
    title: 'Реквизиты для квитанции',
    hint: 'Этими данными подписывается квитанция об оплате в письме родителю. Пока они не заполнены, письмо уходит без квитанции.',
    businessName: 'Название ИП',
    businessNamePlaceholder: 'ИП Иванова Мария Петровна',
    entrepreneurFullName: 'Полное ФИО предпринимателя',
    inn: 'ИНН',
    taxSystem: 'Налоговый режим',
    sellerPosition: 'Должность продавца',
    sellerFullName: 'ФИО продавца',
    saved: 'Реквизиты сохранены.',
    incomplete: 'Реквизиты заполнены не полностью — квитанция в письмах не печатается.',
    innRule: 'ИНН — 12 цифр у ИП или 10 у организации.',
  },
  pages: {
    about: 'Общая информация',
    terms: 'Пользовательское соглашение',
    privacy: 'Политика конфиденциальности',
    personalData: 'Политика обработки персональных данных',
    manageTitle: 'Страницы сайта',
    manageHint:
      'Тексты хранятся в базе: правка вступает в силу сразу, пересборка приложения не нужна.',
    name: 'Название',
    edit: 'Изменить страницу',
    updatedAt: 'Обновлено',
    notFound: 'Страница не найдена.',
    legal: 'Документы',
  },
  news: {
    title: 'Новости',
    manageTitle: 'Управление новостями',
    add: 'Добавить новость',
    edit: 'Изменить новость',
    heading: 'Заголовок',
    headingHint: 'Можно не заполнять — короткое объявление обойдётся без него.',
    untitled: 'Без заголовка',
    summary: 'Анонс',
    summaryHint: 'Короткий текст для ленты. Если оставить пустым, соберём из начала новости.',
    body: 'Текст новости',
    cover: 'Обложка',
    coverHint: 'JPEG, PNG или WebP, до 5 МБ.',
    coverRemove: 'Убрать обложку',
    audience: 'Кому показывать',
    allGroups: 'Всем',
    selectedGroups: 'Выбранным группам',
    publish: 'Опубликовать',
    draft: 'Черновик',
    published: 'Опубликована',
    publishedAt: 'Опубликована',
    channels: 'Разослать в мессенджеры',
    channelsHint:
      'Новость уйдёт в чат каждой выбранной группы. Что не ушло и почему — в разделе «Очередь рассылки».',
    remove: 'Удалить',
    removeConfirm: 'Удалить новость? Действие необратимо.',
    empty: 'Новостей пока нет.',
    emptyFeed: 'Пока нет новостей.',
    notFound: 'Новость не найдена или недоступна.',
    author: 'Автор',
    backToFeed: 'Ко всем новостям',
    outboxTitle: 'Очередь рассылки',
    outboxEmpty: 'Очередь пуста.',
    outboxNews: 'Новость',
    outboxChannel: 'Канал',
    outboxGroup: 'Группа',
    outboxStatus: 'Статус',
    outboxReason: 'Причина',
    outboxCreated: 'Создано',
    outboxAttempts: 'Попытки',
    outboxRetry: 'Повторить',
    outboxRetryDone: 'Сообщение возвращено в очередь.',
    outboxHint:
      'Что уходит в чаты групп и почему что-то не ушло. Сообщения отправляет внешний обработчик — он забирает их отсюда.',
  },
  subscriptions: {
    paymentsTitle: 'Оплата',
    paymentsHint: 'Месячный абонемент оформляется на каждого ученика отдельно.',
    myTitle: 'Мои абонементы',
    registryTitle: 'Абонементы',
    checkoutTitle: 'Оформление абонемента',
    student: 'Ученик',
    item: 'Наименование',
    itemName: (group: string) =>
      `Месячный абонемент для посещения занятий в группе «${group}»`,
    price: 'Цена',
    quantity: 'Кол-во',
    total: 'Сумма',
    toPay: 'Итого к оплате',
    perMonth: 'в месяц',
    month: 'Месяц занятий',
    monthPaid: 'оплачен',
    monthStarted: 'оформлен',
    pastHint: 'Доступны шесть прошедших месяцев, текущий и два следующих.',
    alreadyPaid: (month: string) => `Абонемент за ${month} уже оплачен. Выберите другой месяц.`,
    alreadyOrdered: (month: string) =>
      `Абонемент за ${month} уже оформлен — откроем его, оплачивать заново не нужно.`,
    // Подписи месяцев в именительном падеже, поэтому без предлога:
    // «занятия начались в март» звучало бы как опечатка.
    beforeStart: (month: string, start: string) =>
      `Начало занятий — ${start}, а выбран ${month}. Оформить можно, но проверьте, тот ли это месяц.`,
    notOrdered: 'Не оформлен',
    missingHint: 'Прошедшие месяцы без абонемента показаны в списке отдельной строкой.',
    payMissing: 'Оформить',
    tooOld: 'Оплата через сайт недоступна — обратитесь к администратору студии.',
    comment: 'Комментарий',
    commentHint: 'Необязательно: то, что важно знать администратору.',
    consent: 'Согласие на обработку персональных данных',
    consentLink: 'Политика обработки персональных данных',
    terms: 'Я прочитал(а) и принимаю',
    termsLink: 'пользовательское соглашение',
    submit: 'Оформить абонемент',
    created: 'Абонемент оформлен.',
    one: 'Абонемент',
    number: 'Номер',
    status: 'Статус',
    period: 'Месяц',
    amount: 'Сумма',
    createdAt: 'Оформлен',
    paidAt: 'Оплачен',
    paidManually: 'оплата отмечена администратором',
    parent: 'Родитель',
    order: 'Оформить',
    pay: 'Оплатить',
    openOrder: 'Открыть абонемент',
    allPaid: 'Ближайшие месяцы оплачены.',
    cancel: 'Отменить абонемент',
    cancelConfirm: 'Отменить неоплаченный абонемент?',
    canceled: 'Абонемент отменён.',
    markPaid: 'Отметить оплату',
    markPaidCash: 'Наличными',
    markPaidCashless: 'Безналичными',
    markPaidForm: 'Форма расчёта — она попадёт в квитанцию',
    markPaidConfirm: 'Отметить абонемент оплаченным? Действие нельзя отменить.',
    markPaidDone: 'Оплата отмечена.',
    markPaidHint: 'Для оплаты наличными или переводом — онлайн-оплата ставит статус сама.',
    returnTitle: 'Оплата абонемента',
    returnChecking: 'Проверяем оплату — обычно это занимает несколько секунд.',
    returnPaid: 'Оплата прошла, абонемент оплачен.',
    returnCanceled: 'Абонемент отменён.',
    // Возврат с формы оплаты сам по себе ничего не подтверждает: платёж
    // подтверждает уведомление на сервер, и оно может немного опоздать.
    returnPending:
      'Платёж пока не подтверждён. Если деньги списаны, статус обновится сам — загляните в «Мои абонементы» через несколько минут.',
    empty: 'Абонементов пока нет.',
    emptyRegistry: 'По этим условиям абонементов нет.',
    noStudents: 'Сначала добавьте ученика — абонемент оформляется на конкретного ребёнка.',
    notFound: 'Абонемент не найден.',
    back: 'Ко всем абонементам',
    searchPlaceholder: 'Поиск по фамилии или номеру',
    anyStatus: 'Любой статус',
    anyMonth: 'Все месяцы',
    statusAwaitingPayment: 'Ожидает оплаты',
    statusPaid: 'Оплачен',
    statusCanceled: 'Отменён',
    group: 'Группа',
    print: 'Распечатать',
    printTitle: 'Абонемент',
    printOnlyPaid: 'Печать доступна после оплаты.',
    printAction: 'Печать',
    printSignature: 'Подпись администратора',
    printIssued: 'Дата печати',
  },
  services: {
    title: 'Услуги',
    hint: 'Дополнительные услуги: индивидуальные занятия, костюмы, поездки. Расчётного месяца у них нет — их покупают когда угодно и сколько угодно раз.',
    add: 'Добавить услугу',
    edit: 'Изменить услугу',
    name: 'Название',
    description: 'Описание',
    price: 'Стоимость',
    visibility: 'Кому показывать',
    visibilityAll: 'Всем родителям',
    visibilityGroups: 'Выбранным группам',
    visibilityLink: 'Никому — только по ссылке',
    visibilityHint:
      'Плитка появится на странице «Оплата». Скрытую услугу можно оплатить по ссылке — она работает всегда.',
    groups: 'Группы',
    sortOrder: 'Порядок плиток',
    sortOrderHint: 'Меньше — выше. При равных значениях плитки идут по алфавиту.',
    active: 'Услуга продаётся',
    closed: 'Не продаётся',
    showClosed: 'Показывать закрытые',
    linkOnly: 'Только по ссылке',
    forAll: 'Всем',
    copyLink: 'Скопировать ссылку',
    linkCopied: 'Ссылка на оплату скопирована.',
    linkCopyFailed: 'Не удалось скопировать. Скопируйте адрес вручную.',
    paidCount: 'Оплат',
    empty: 'Услуг пока нет. Добавьте первую — она появится плиткой на странице оплаты.',
    tilesTitle: 'Дополнительные услуги',
    order: 'Оплатить',
    checkoutTitle: 'Оплата услуги',
    notFound: 'Услуга не найдена или больше не продаётся.',
    noStudents: 'Чтобы оплатить услугу, сначала добавьте ученика.',
    student: 'Ученик',
    selectStudent: 'Для кого',
    one: 'Услуга',
    number: 'Номер',
    amount: 'Стоимость',
    createdAt: 'Оформлена',
    paidAt: 'Оплачена',
    back: 'К списку',
    myTitle: 'Мои услуги',
    myEmpty: 'Оплаченных услуг пока нет.',
    registryTitle: 'Услуги',
    registryEmpty: 'Оплат услуг пока нет.',
    tabSubscriptions: 'Абонементы',
    tabServices: 'Услуги',
    reportTitle: 'Отчёт по услугам',
    reportHint:
      'Оплаченные услуги за период — по дате поступления денег. Расчётного месяца у услуги нет, поэтому второго способа отнести её к периоду не существует.',
    reportEmpty: 'За выбранный период оплаченных услуг нет.',
    serviceFilter: 'Услуги',
    allServices: 'Все услуги',
  },
  chats: {
    tab: 'Чаты',
    hint: 'Чаты, в которые добавлен бот. Чтобы чат появился здесь, добавьте бота в чат группы или напишите в нём «/start@имя_бота».',
    empty: 'Бот пока не добавлен ни в один чат.',
    title: 'Чат',
    type: 'Тип',
    botStatus: 'Бот',
    group: 'Группа',
    lastSeen: 'Последнее событие',
    free: 'Не привязан',
    statusMember: 'Участник',
    statusAdministrator: 'Администратор',
    statusLeft: 'Вышел',
    statusKicked: 'Удалён',
    relayNotConfigured: 'Рассылка не подключена: не настроен внешний обработчик.',
    relaySilent: 'Обработчик ни разу не выходил на связь с момента перезапуска приложения.',
    relaySeen: (when: string) => `Обработчик выходил на связь: ${when}.`,
  },
  emails: {
    tabMessengers: 'Мессенджеры',
    tabEmails: 'Письма',
    title: 'Очередь писем',
    hint: 'Письма уходят из очереди с повторами. Пока SMTP не настроен, они копятся здесь, а их текст виден в логе приложения.',
    empty: 'Писем пока нет.',
    to: 'Кому',
    subject: 'Тема',
    kind: 'Тип',
    attempts: 'Попытки',
    nextAttempt: 'Следующая попытка',
    sentAt: 'Отправлено',
    retry: 'Повторить',
    retryDone: 'Письмо возвращено в очередь.',
    receipt: 'Квитанция №',
    kindConfirmEmail: 'Подтверждение адреса',
    kindPasswordReset: 'Сброс пароля',
    kindSubscriptionPaid: 'Оплата абонемента',
  },
  reports: {
    title: 'Отчёт по оплатам',
    hint: 'Оплаченные абонементы за период — по группам и ученикам. Неоплаченные сюда не попадают, их видно в разделе «Абонементы».',
    from: 'С',
    to: 'По',
    basis: 'Период считать',
    basisPaymentDate: 'по дате оплаты',
    basisPeriod: 'по расчётному месяцу',
    basisHint:
      'По дате оплаты — сколько денег поступило за эти дни. По расчётному месяцу — сколько оплачено за сами месяцы занятий: оплата вперёд попадёт в свой месяц, а не в день платежа.',
    groups: 'Группы',
    allGroups: 'Все группы',
    thisMonth: 'Текущий месяц',
    previousMonth: 'Прошлый месяц',
    year: 'С начала года',
    total: 'Итого',
    totalFor: (range: string) => `Итого за ${range}`,
    count: 'Оплат',
    excel: 'Выгрузить в Excel',
    excelDone: 'Файл сохранён.',
    subscription: 'Абонемент',
    period: 'Расчётный месяц',
    paidAt: 'Дата оплаты',
    form: 'Форма оплаты',
    source: 'Как оплачен',
    receipt: 'Квитанция',
    amount: 'Сумма',
    empty: 'За выбранный период оплат нет.',
  },
  monthReport: {
    title: 'Оплаты за месяц',
    hint: 'Кто оплатил месяц занятий, а кто нет. Отчёт рассчитан на телефон: откройте перед занятием.',
    month: 'Месяц занятий',
    filterAll: 'Все',
    filterPaid: 'Оплачены',
    filterUnpaid: 'Не оплачены',
    unpaid: 'не оплачен',
    paidCount: 'оплатили',
    unpaidCount: 'не оплатили',
    collected: (month: string) => `Собрано за ${month}`,
    // Итоги считаются по всему месяцу: фильтр меняет только видимые строки,
    // иначе сумма по группе прыгала бы от переключения.
    totalsHint: 'Итоги считаются по всему месяцу и не зависят от фильтра.',
    empty: 'За этот месяц показывать нечего.',
    emptyPaid: 'За этот месяц ещё никто не оплатил.',
    emptyUnpaid: 'Все оплатили — должников нет.',
  },
  payments: {
    registryTitle: 'Платежи',
    registryHint:
      'Все обращения к ЮKassa — и по абонементам, и по услугам. Красная пометка означает, что деньги списаны, а оплаченное ими не закрыто: такую строку нужно разобрать вручную.',
    what: 'За что',
    created: 'Создан',
    paidAt: 'оплачен',
    empty: 'Платежей пока нет.',
    anyStatus: 'Любой статус',
    statusPending: 'Ожидает оплаты',
    statusWaiting: 'Ждёт подтверждения',
    statusSucceeded: 'Оплачен',
    statusCanceled: 'Отменён',
  },
  validation: {
    required: 'Заполните поле.',
    email: 'Некорректный адрес.',
    nameChars: 'Допустимы только буквы, дефис и апостроф.',
    phone: 'Некорректный номер телефона.',
    maxLength: 'Слишком длинное значение.',
    date: 'Некорректная дата.',
    birthDateFuture: 'Дата рождения не может быть в будущем.',
    money: 'Укажите сумму, например 3500 или 3500,50.',
    chatLink: 'Ссылка должна начинаться с http:// или https://.',
    groupRequired: 'Выберите группу.',
    parentRequired: 'Выберите родителя.',
    monthRequired: 'Выберите месяц.',
    consentRequired: 'Без согласия на обработку персональных данных оформить абонемент нельзя.',
    termsRequired: 'Подтвердите, что принимаете пользовательское соглашение.',
  },
  groups: {
    title: 'Группы',
    add: 'Добавить группу',
    edit: 'Изменить группу',
    name: 'Название',
    description: 'Описание',
    price: 'Стоимость месяца',
    students: 'Учеников',
    chats: 'Чаты группы',
    telegram: 'Ссылка на Telegram',
    whatsapp: 'Ссылка на WhatsApp',
    max: 'Ссылка на MAX',
    broadcastChat: 'Чат для рассылки',
    broadcastChatHint:
      'Куда бот отправляет новости группы. Ссылка-приглашение выше для этого не годится: по ней бот писать не может.',
    broadcastChatNone: 'Не рассылать',
    broadcastChatEmpty: 'Бот пока не добавлен ни в один свободный чат.',
    active: 'Группа набирает учеников',
    showClosed: 'Показывать закрытые',
    closed: 'Закрыта',
    empty: 'Групп пока нет. Добавьте первую — без неё нельзя завести ученика.',
    priceHint: 'Цена по умолчанию. Для отдельного ученика её можно изменить в карточке ученика.',
  },
  students: {
    myTitle: 'Мои ученики',
    allTitle: 'Ученики',
    add: 'Добавить ученика',
    addForParent: 'Добавить ученика родителю',
    edit: 'Изменить данные',
    contract: 'Договор',
    birthDate: 'Дата рождения',
    classesStart: 'Начало занятий',
    classesStartHint:
      'С этой даты считаются неоплаченные месяцы. По умолчанию — день, когда ученика завели.',
    group: 'Группа',
    age: 'Возраст',
    price: 'Стоимость месяца',
    priceReadOnly: 'Стоимость назначает студия — изменить её нельзя.',
    parent: 'Родитель',
    parentSearch: 'Начните вводить фамилию или адрес',
    individualPrice: 'Индивидуальная стоимость',
    individualPriceHint: 'Пусто — берётся цена группы.',
    active: 'Занимается',
    inactive: 'Не занимается',
    showInactive: 'Показывать неактивных',
    search: 'Поиск по фамилии или имени',
    allGroups: 'Все группы',
    history: 'История изменений',
    historyEmpty: 'Изменений не было.',
    changedAt: 'Когда',
    changedBy: 'Кто',
    field: 'Что изменилось',
    oldValue: 'Было',
    newValue: 'Стало',
    empty: 'Учеников пока нет.',
    emptyMine: 'Вы ещё не добавили ни одного ученика.',
    noGroups: 'Пока нет ни одной открытой группы — обратитесь к администратору студии.',
    yearsShort: 'лет',
  },
  users: {
    title: 'Пользователи',
    hint: 'Учётные записи родителей и администраторов. Заведённая здесь запись готова к входу сразу — подтверждать адрес не нужно.',
    add: 'Добавить пользователя',
    edit: 'Изменить профиль',
    search: 'Поиск по фамилии, имени или адресу',
    role: 'Роль',
    anyRole: 'Все роли',
    roleAdmin: 'Администратор',
    roleParent: 'Родитель',
    showInactive: 'Показывать отключённых',
    students: 'Учеников',
    createdAt: 'Заведён',
    status: 'Состояние',
    active: 'Доступ открыт',
    inactive: 'Доступ закрыт',
    unconfirmed: 'Адрес не подтверждён',
    password: 'Пароль',
    passwordHint: 'Задайте пароль и передайте его человеку — письмо о подтверждении не отправляется.',
    grantAdmin: 'Сделать администратором',
    revokeAdmin: 'Снять права администратора',
    grantAdminConfirm:
      'Выдать права администратора? Пользователь получит доступ ко всем разделам, оплатам и отчётам.',
    revokeAdminConfirm: 'Снять права администратора?',
    adminChanged: 'Права изменены. Пользователю нужно войти заново.',
    deactivate: 'Закрыть доступ',
    activate: 'Открыть доступ',
    deactivateConfirm: 'Закрыть доступ? Данные останутся, но войти пользователь не сможет.',
    activated: 'Доступ открыт.',
    deactivated: 'Доступ закрыт.',
    sendConfirmation: 'Выслать подтверждение',
    confirmationSent: 'Письмо со ссылкой поставлено в очередь.',
    remove: 'Удалить',
    removeConfirm: (name: string) =>
      `Удалить учётную запись «${name}»? Действие необратимо. Если за пользователем числятся ученики или оплаты, удалить её нельзя — закройте доступ.`,
    removed: 'Учётная запись удалена.',
    created: 'Пользователь заведён.',
    empty: 'По этим условиям пользователей нет.',
    // Кнопки не прячем: сервер откажет и объяснит причину понятнее, чем
    // исчезнувший пункт меню. Подпись предупреждает заранее.
    selfHint: 'Это вы: снять с себя права, закрыть доступ или удалить запись нельзя.',
  },
  common: {
    save: 'Сохранить',
    cancel: 'Отмена',
    close: 'Закрыть',
    add: 'Добавить',
    loading: 'Загружаем…',
    loadFailed: 'Не удалось загрузить данные.',
    inDevelopment: 'Раздел появится на следующих этапах разработки.',
    notFound: 'Страница не найдена',
    backHome: 'Вернуться на главную',
    error: 'Ошибка',
    success: 'Готово',
  },
} as const;
